export const GET_DATA_ACCESS_POLICY = "GET_DATA_ACCESS_POLICY";
export const RESET_DATA_ACCESS_POLICY = "RESET_DATA_ACCESS_POLICY";